import swal from "sweetalert2"; import swal from "sweetalert2";
<template>
  <div class="content">
    <SingleCardLayout :fileIds="fileIds" :title="title" :descriptions="descriptions"></SingleCardLayout>
    <card class="text-left">
      <div class="row">
        <label class="col-sm-2 col-form-label">갤러리 ID</label>
        <div class="col-sm-3">
          <base-input>
            <p class="form-control-static">{{ collectionId }}</p>
          </base-input>
        </div>
        <base-button v-if="type === 10" class="update-button col-sm-3" @click.prevent="onClickUpdateType(30)" type="confirm">팁으로변경</base-button>
        <base-button v-if="type === 30" class="update-button col-sm-3" @click.prevent="onClickUpdateType(10)" type="confirm">갤러리로변경</base-button>
        <base-button class="update-button col-sm-3" @click.prevent="goSharePage" type="confirm">공유페이지</base-button>
      </div>
      <div class="row">
        <label class="col-md-2 col-form-label key">작성자</label>
        <div class="col-md-10" v-if="isAdminAuthor">
          <el-select class="select-primary" size="large" placeholder="작성자" v-model="selectedAuthorId">
            <el-option v-for="option in authorOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
          </el-select>
          <base-button class="update-button col-6" @click.prevent="onClickUpdateAuthor" type="confirm">업데이트</base-button>
        </div>
        <label class="col-md-10 col-form-label value" v-if="!isAdminAuthor"
          ><a class="pointer" @click="goUserDetail(userId)">{{ nickname }}({{ userId }})</a></label
        >
      </div>
      <!--      <div class="row">-->
      <!--        <label class="col-sm-2 col-form-label">작성자</label>-->
      <!--        <div class="col-sm-10">-->
      <!--          <base-input>-->
      <!--            <p class="form-control-static">-->
      <!--              <a class="pointer" @click="goUserDetail(userId)">{{ nickname }}({{ userId }})</a>-->
      <!--            </p>-->
      <!--          </base-input>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="row">
        <label class="col-sm-2 col-form-label">조회수</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ viewCount }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">댓글수</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ commentCount }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">좋아요수</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ likeCount }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">저장수</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ pinCount }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">태그</label>
        <div class="col-sm-4">
          <base-input placeholder="태그" v-model="stringTagNames">
            <span slot="helpBlock" class="form-text"></span>
          </base-input>
        </div>
        <div class="col-sm-4">
          <base-button class="footer-buttons col-6" @click="onClickUpdateTag" type="success">업데이트</base-button>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">멤버</label>
        <div class="col-sm-4">
          <el-select multiple class="select-primary" size="large" placeholder="멤버선택" v-model="members.members" @change="changeMembers">
            <el-option v-for="option in members.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
          </el-select>
          <el-popover trigger="hover" placement="top">
            <div>
              <div class="popover-body">그룹 또는 멤버를 선택하실수 있습니다</div>
            </div>
            <base-button slot="reference"> ? </base-button>
          </el-popover>
        </div>
        <div class="col-sm-4">
          <base-button class="footer-buttons col-6" @click="setCollectionMembers" type="success">저장</base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <h4 class="card-title text-left">등록시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="등록시간">
                <el-date-picker type="datetime" placeholder="등록시간" v-model="regTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">예약노출시작시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="시작시간">
                <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">예약노출종료시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="종료시간">
                <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <base-button class="col-md-12" @click="setCollectionTimes" type="success">시간저장</base-button>
          </div>
        </div>
      </div>
    </card>
    <div class="row actions">
      <div v-if="state !== -1" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="deleteCollection" type="success">삭제</base-button>
      </div>
      <div v-if="state !== 0" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="hideCollection" type="success">숨김</base-button>
      </div>
      <div v-if="state !== 1" class="col-md-2">
        <base-button class="col-md-12" @click="showCollection" type="success">표시</base-button>
      </div>
      <div class="col-md-2">
        <base-button class="col-md-12" @click="showModal" type="success">띄워주자</base-button>
      </div>
      <div class="col-md-2">
        <base-button class="col-md-12" @click="onClickComments" type="success">댓글 보기</base-button>
      </div>
      <div v-if="state === 1" class="col-md-2">
        <base-button class="col-md-12" @click="sendNotification" type="success" :disabled="isPicked">알림 전송</base-button>
      </div>
    </div>
    <div class="pick-section">
      <h4 class="section-title pull-left">띄워준 내역</h4>
      <card>
        <div class="col-md-12">
          <el-table :data="raisedCollections">
            <el-table-column
              v-for="column in showHistoryColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
            <el-table-column prop="adminId" label="운영자ID" />
            <el-table-column :min-width="100" align="right" label="삭제">
              <div slot-scope="props">
                <base-button
                  @click.native="deleteRaisedCollection(props.row.id, props.row.type, props.row.artistId)"
                  class="icon-simple-delete btn-link"
                  type="warning"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-pencil" />
                </base-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
    <div class="pick-section">
      <h4 class="section-title pull-left">노출 내역</h4>
      <card>
        <div class="col-md-12">
          <el-table :data="showHistory">
            <el-table-column
              v-for="column in showHistoryColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
          </el-table>
        </div>
      </card>
    </div>

    <div class="pick-section">
      <h4 class="section-title pull-left">신고 내역</h4>
      <card>
        <div class="row">
          <ReportsForContentTableView class="col-12" :reports="reports" />
        </div>
      </card>
    </div>
    <CollectionDetailModal
      :key="componentKey"
      :collectionId="collectionId"
      :members="members.members"
      :unitId="unitId"
      :shouldShow="collectionModal.show"
      :onConfirm="onCollectionModal"
      :onCancel="onCancelModal"
    ></CollectionDetailModal>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import SingleCardLayout from "@/pages/Components/SingleCardLayout.vue";
import CollectionDetailModal from "./CollectionDetailModal.vue";
import ReportsForContentTableView from "@/pages/Reports/ReportsForContentTableView";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import swal from "sweetalert2";
import { BlipNamespace } from "@/common/BlipNamespace";
import { formatDateTime } from "@/util/DateUtils";
import * as _ from "lodash";
import Endpoints from "@/common/Endpoints";

export default {
  components: {
    BaseInput,
    Card,
    SingleCardLayout,
    CollectionDetailModal,
    ReportsForContentTableView,
  },
  async created() {
    if (!this.$route.query.collectionId) {
      Toast.error("잘못된접근입니다");
      history.go(-1);
    }

    this.collectionId = Number(this.$route.query.collectionId);
    await this.checkPicked();
    await this.getCollectionDetail();
    await this.getArtistUnits();
    await this.getArtistMembers();
    await this.getRaisedCollections();
    await this.getShowHistoryList();
    await this.getReports();
  },
  data() {
    return {
      componentKey: 0,
      unitId: null,
      title: null,
      type: null,
      fileIds: [],
      descriptions: [],
      collectionId: null,
      userId: null,
      idHash: null,
      nickname: null,
      description: null,
      tags: [],
      tagNames: [],
      stringTagNames: null,
      state: null,
      isAdminAuthor: false,
      authorOptions: [],
      selectedAuthorId: null,
      isPicked: true,
      members: {
        members: [],
        options: [],
      },
      likeCount: 0,
      viewCount: 0,
      commentCount: 0,
      pinCount: 0,
      regTime: null,
      startTime: null,
      endTime: null,
      reports: [],
      raisedCollections: [],
      collectionModal: {
        show: false,
      },
      showHistoryColumns: [
        {
          prop: "typeName",
          label: "구분",
          minWidth: 50,
        },
        {
          prop: "startTime",
          label: "시작시간",
          minWidth: 150,
        },
        {
          prop: "endTime",
          label: "종료시간",
          minWidth: 150,
        },
        {
          prop: "weight",
          label: "가중치",
          minWidth: 120,
        },
        {
          prop: "artistName",
          label: "해당아티스트",
          minWidth: 120,
        },
      ],
      showHistory: [],
    };
  },
  // watch: {
  //   members: {
  //     handler(newVal) {
  //       console.log(newVal);
  //       if (newVal.members.includes(this.members.options[0].value)) {
  //         this.members.members = [this.members.options[0].value];
  //       }
  //     },
  //     deep: true
  //   }
  // },

  methods: {
    async checkPicked() {
      const result = await this.$axios.get(`/adminContents?contentId=${this.collectionId}&namespace=100`);
      this.isPicked = result.data.data.isPicked;
    },
    async changeMembers() {
      const unitArtistId = this.members.options[0].value;
      if (this.members.members.includes(unitArtistId)) {
        this.members.members = [unitArtistId];
      }
    },
    async getCollectionDetail() {
      await this.$axios.get(`/collection/${this.collectionId}`).then((res) => {
        const data = res.data.data;
        this.title = data.title;
        this.idHash = data.idHash;
        this.fileIds = [data.coverFileId];
        this.type = data.type;
        this.descriptions = [];
        for (let j = 0; j < data.medias.length; j++) {
          this.fileIds.push(data.medias[j].fileId);
          this.descriptions.push(data.medias[j].title);
        }
        this.unitId = data.unitId;
        this.collectionId = data.collectionId;
        this.userId = data.userId;
        this.nickname = data.nickname;
        this.description = data.description;
        this.state = data.state;
        this.tags = data.tags;
        this.tags.forEach((item) => {
          this.tagNames.push(item.tag);
        });
        this.stringTagNames = this.tagNames.toString();
        data.members.forEach((item) => {
          this.members.members.push(item.id);
        });

        this.likeCount = data.likeCount;
        this.viewCount = data.viewCount;
        this.commentCount = data.commentCount;
        this.pinCount = data.pinCount;
        this.regTime = data.regTime;
        this.startTime = data.startTime;
        this.endTime = data.endTime;
      });

      const roleResult = await this.$axios.get(`/users/${this.userId}/roles`);
      this.isAdminAuthor = _.some(roleResult.data.data, (role) => {
        return role.includes("blipContentAdmin") || role.includes(`dummyUnitFollower/${this.unitId}`);
      });

      if (this.isAdminAuthor) {
        await this.getDummyAuthors(this.unitId);
      }
    },
    async getDummyAuthors(unitId) {
      try {
        const dummyUsers = await this.$axios.get(`/artistUnit/${unitId}/dummyUsers`);
        const contentAdmins = await this.$axios.get(`/artistUnit/${unitId}/contentAdmins`);

        this.dummyAuthors = dummyUsers.data.data.users.concat(contentAdmins.data.data.users);

        this.selectedAuthorId = this.userId;

        this.authorOptions = [
          { label: `${this.nickname}(${this.userId})`, value: this.userId },
          ...this.dummyAuthors
            .filter((author) => author.id !== this.userId)
            .map((author) => ({
              label: `${author.nickname}(${author.id})`,
              value: author.id,
            })),
        ];
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async getArtistUnits() {
      return this.$axios.get(`/artistUnit/${this.unitId}`, null).then((res) => {
        const data = res.data.data;
        if (data.isGroup === 1) {
          this.members.options.push({ label: data.blipName, value: data.artistId });
        }
      });
    },
    async getArtistMembers() {
      return this.$axios.get(`/artistUnit/${this.unitId}/members`, null).then((res) => {
        const data = res.data.data;
        if (data.length > 0) {
          data.forEach((item) => {
            const option = {};
            option.label = item.blipName ? item.blipName : item.name;
            option.value = item.artistId;
            this.members.options.push(option);
          });
        }
      });
    },
    async getRaisedCollections() {
      return this.$axios.get(`/collection/${this.collectionId}/raisedCollections`, null).then((res) => {
        this.raisedCollections = res.data.data;
        this.raisedCollections = this.raisedCollections.map((item) => {
          if (item.startTime) {
            item.startTime = formatDateTime(item.startTime);
          }
          if (item.endTime) {
            item.endTime = formatDateTime(item.endTime);
          }
          return item;
        });
      });
    },
    async getShowHistoryList() {
      return this.$axios.get(`/collection/${this.collectionId}/showHistory`, null).then((res) => {
        this.showHistory = res.data.data;
        this.showHistory = this.showHistory.map((item) => {
          if (item.startTime) {
            item.startTime = formatDateTime(item.startTime);
          }
          if (item.endTime) {
            item.endTime = formatDateTime(item.endTime);
          }
          return item;
        });
      });
    },

    async getReports() {
      try {
        const result = await this.$axios.get(`/collection/${this.collectionId}/reports`);
        this.reports = result.data.data;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },

    async setCollectionMembers() {
      return this.$axios.put(`/collection/${this.collectionId}/members`, { param: { unitId: this.unitId, members: this.members.members } }).then((res) => {
        Toast.success("멤버가 설정되었습니다");
        this.componentKey += 1;
      });
    },
    async deleteRaisedCollection(id, type, artistId) {
      swal
        .fire({
          title: "삭제 확인",
          text: `삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .delete(`/collection/${this.collectionId}/raisedCollection`, { params: { id, type, artistId, unitId: this.unitId } })
                .then((res) => {
                  Toast.success("삭제되었습니다");
                  this.getRaisedCollections();
                });
            } catch (err) {
              Toast.error("삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    async setCollectionTimes() {
      return this.$axios
        .put(`/collection/${this.collectionId}/times`, {
          param: { unitId: this.unitId, startTime: this.startTime, endTime: this.endTime, regTime: this.regTime },
        })
        .then((res) => {
          Toast.success("시간이 설정되었습니다");
          this.componentKey += 1;
        });
    },

    async onClickUpdateTag() {
      if (this.stringTagNames === null || this.stringTagNames.length === 0) {
        Toast.error("태그를 입력해주세요");
        return;
      }
      this.tagNames = this.stringTagNames.split(",");
      return this.$axios.put(`/collection/${this.collectionId}/tag`, { param: { unitId: this.unitId, tags: this.tagNames } }).then((res) => {
        Toast.success("태그가 업데이트되었습니다");
      });
    },

    async deleteCollection() {
      swal
        .fire({
          title: "삭제 확인",
          text: `${this.collectionId} 갤러리 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/collection/${this.collectionId}/state`, {
                  params: { unitId: this.unitId, state: -1 },
                })
                .then((res) => {
                  Toast.success("갤러리 삭제 되었습니다");
                  this.state = -1;
                });
            } catch (err) {
              Toast.error("갤러리 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    async hideCollection() {
      swal
        .fire({
          title: "숨김 확인",
          text: `${this.collectionId} 갤러리 숨김하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/collection/${this.collectionId}/state`, {
                  params: { unitId: this.unitId, state: 0 },
                })
                .then((res) => {
                  Toast.success("갤러리 숨김 되었습니다");
                  this.state = 0;
                });
            } catch (err) {
              Toast.error("갤러리 숨김 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async showCollection() {
      swal
        .fire({
          title: "표시 확인",
          text: `${this.collectionId} 갤러리 표시하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "표시",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/collection/${this.collectionId}/state`, {
                  params: { unitId: this.unitId, state: 1 },
                })
                .then((res) => {
                  Toast.success("갤러리 표시 되었습니다");
                  this.state = 1;
                });
            } catch (err) {
              Toast.error("갤러리 표시 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async onClickUpdateAuthor() {
      try {
        const result = await this.$axios.put(`/collection/${this.collectionId}/author`, {
          userId: this.selectedAuthorId,
        });
        window.Toast.success(result.data.data.message);
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async onClickUpdateType(type) {
      try {
        const result = await this.$axios.put(`/collection/${this.collectionId}/type`, {
          type,
        });
        window.Toast.success(result.data.data.message);
        this.type = type;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    goSharePage() {
      window.open(`${Endpoints.sharePageUrl}/c/${this.idHash}`);
    },
    showModal() {
      this.collectionModal.show = true;
    },
    onClickComments() {
      this.$router.push(`/comment/all?namespace=${BlipNamespace.COLLECTION}&unitId=${this.unitId}&contentId=${this.collectionId}`);
    },
    async sendNotification() {
      swal
        .fire({
          title: "알림",
          text: `${this.title} 알림을 전송 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "알림",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              await this.$axios.put(`/collection/${this.collectionId}/notification`).then((res) => {
                Toast.success("갤러리 알림이 전송되었습니다");
              });

              await this.checkPicked();
            } catch (err) {
              Toast.error("갤러리 알림 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    onCollectionModal() {},
    onCancelModal() {
      this.collectionModal.show = false;
      this.getRaisedCollections();
    },
    goUserDetail(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
  },
};
</script>
<style scoped lang="scss">
.actions {
  margin-bottom: 40px;
}
.pointer {
  cursor: pointer;
}
</style>
